import clientStorage from "../utils/client-storage";

export function reorder(config) {
  const nextConfig = JSON.parse(JSON.stringify(config));
  const cacheOrder = clientStorage.getConfigItemsOrder();
  const isApplied = cacheOrder != null
    && cacheOrder.configId === nextConfig.id
    && cacheOrder.configVersion === nextConfig.version
    && Array.isArray(cacheOrder.sections);

  nextConfig.sections = nextConfig.sections.shuffle();
  nextConfig.sections.forEach((section) => {
    section.blocks = section.blocks.shuffle();
    section.blocks.sort((a) => a.type === "wide" ? -1 : 1);
  });

  if (isApplied) {
    nextConfig.sections.sort((a, b) => {
      const ai = cacheOrder.sections.findIndex((s) => s.name === a.name);
      const bi = cacheOrder.sections.findIndex((s) => s.name === b.name);
      return ai - bi;
    });

    nextConfig.sections.forEach((section) => {
      const blocksOrder = cacheOrder.sections.find((s) => s.name === section.name).blocks;
      section.blocks.sort((a, b) => {
        const ai = blocksOrder.findIndex((block) => block === a.name);
        const bi = blocksOrder.findIndex((block) => block === b.name);
        return ai - bi;
      });
    });
  }

  clientStorage.setConfigItemsOrder({
    configId: config.id,
    configVersion: config.version,
    sections: nextConfig.sections.map((section) => {
      return {
        name: section.name,
        blocks: section.blocks.map((block) => block.name),
      };
    })
  });

  return nextConfig;
}

export default {
  reorder,
};